var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon / graph / table") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-/-graph-/-table",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#FFFFFF",
    x: 2,
    y: 5,
    width: 20,
    height: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 7.5,
    x2: 22,
    y2: 7.5,
    id: "Line",
    stroke: "#FFFFFF",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 11.5,
    x2: 22,
    y2: 11.5,
    id: "Line",
    stroke: "#FFFFFF",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 15.5,
    x2: 22,
    y2: 15.5,
    id: "Line",
    stroke: "#FFFFFF",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.5,
    y1: 5.5,
    x2: 8.5,
    y2: 18.5,
    id: "Line-4",
    stroke: "#FFFFFF",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.5,
    y1: 5.5,
    x2: 15.5,
    y2: 18.5,
    id: "Line-4",
    stroke: "#FFFFFF",
    strokeLinecap: "square"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.59c17a985dca66a48aac78d7a508d1cc.svg";
export { ForwardRef as ReactComponent };